import type { Locale } from "date-fns/locale";
// Subpaths, not the `date-fns/locale` barrel: bundlers tree-shake it, but Vitest leaves node_modules
// unbundled, so the barrel evaluates every locale (~450ms) in each test file that reaches this module.
import { de } from "date-fns/locale/de";
import { enUS } from "date-fns/locale/en-US";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { zhCN } from "date-fns/locale/zh-CN";

export const getDateFnsLocale = (i18nLocale?: string): Locale => {
  switch (i18nLocale) {
    case "en":
      return enUS;
    case "es":
      return es;
    case "fr":
      return fr;
    case "zh":
      return zhCN;
    case "de":
      return de;
    default:
      return enUS;
  }
};
